import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";

//COMPONENTS
import Controller from "./files/controller";
import Event from "./files/event";

function PodRouter() {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        setIsLoaded(true);
    }, []);

    return (
        <div>
            {isLoaded && (
                <div>
                    <Routes>
                        <Route path="/" element={<Controller />} />
                        <Route path="/newEvent" element={<Event modify={false} />} />
                        <Route path="/modifyEvent/:id" element={<Event modify={true} />} />
                    </Routes>
                </div>
            )}
        </div>
    );
}

export default PodRouter;
